
/**
 * Report item type → static locale key 매핑
 * 실제 번역은 static-locales/{locale}.json의 "report-item-{type}" 키에서 가져옴
 */
export const reportItemTypesMap: Record<string, string> = {
  "rep-points": "report-item-rep-points",
  "rep-total": "report-item-rep-total",
  "rep-as-is": "report-item-rep-as-is",
  "rep-options-patient-term": "report-item-rep-options-patient-term",
  "list-all-as-checkbox": "report-item-list-all-as-checkbox",
  "rep-formatted-single": "report-item-rep-formatted-single",
  "rep-formatted-mixed": "report-item-rep-formatted-mixed",
  "rep-multi-text-nested": "report-item-rep-multi-text-nested",
  "rep-label": "report-item-rep-label",
  "rep-tree-doctor-term": "report-item-rep-tree-doctor-term",
  "rep-map-options": "report-item-rep-map-options",
  "rep-date-to-age": "report-item-rep-date-to-age",
  "rep-whole-body": "report-item-rep-whole-body",
};
